/* eslint-disable func-names */
/* eslint-disable no-new-wrappers */
/* eslint-disable no-restricted-globals */
/* eslint-disable func-names */
import React from 'react';
import { FormattedMessage } from 'react-intl';
import messages from 'aurora-translations';
import { isEmpty, isArray, isObject } from 'lodash';
import JSZip from 'jszip';
import { saveAs } from 'save-as';
import writtenNumber from 'written-number';
import landIcon from 'aurora-images/Plot-img.svg';
import unitIcon from 'aurora-images/Unit-sunset.svg';
import unitLeaseIcon from 'aurora-images/LeaseUnit.svg';
import buildingIcon from 'aurora-images/Building-img.svg';
import offPlan from 'aurora-images/offPlan1x.svg';
import format from 'date-fns/format';
import history from 'aurora-utils/history';
import moment from 'moment';
import filters from 'aurora-utils/filters.json';
import { en, ar } from 'date-fns/locale';
import { formatWithOptions } from 'date-fns/fp';
import { INSANT_SERVICES_TYPES } from 'aurora-utils/constants';
import { PROPERTY_TYPE } from '../containers/Routes/DashboardHome/keys';

export const getPropertTypeLabel = (type, property, isAr) => {
  if (type === 1) {
    return 'Land';
  }
  if (type === 2) {
    return isAr ? property?.buildingClassificationAr : property?.buildingClassificationEn;
  }
  if (type === 4) {
    return isAr ? property?.unitClassificationAr : property?.unitClassificationEn;
  }
  return 'Land';
};

export const getContractType = id => {
  if (id === 'Industrial') {
    return 'industrial';
  }
  if (id === 'Commercial') {
    return 'commercial';
  }
  if (id === 'Residential') {
    return 'residential';
  }
  if (id === 'DiplomaticOffices') {
    return 'diplomat';
  }
  if (id === 'Government') {
    return 'government';
  }
  if (id === 'PublicBenefitAssociation') {
    return 'public_benefit_association';
  }
  return id;
};

export const getPropertType = id => {
  if (id === 1) {
    return 'Land';
  }
  if (id === 2) {
    return 'Building';
  }
  if (id === 3) {
    return 'Floor';
  }
  if (id === 4) {
    return 'Unit';
  }
  if (id === 5) {
    return 'Villa';
  }
  return 'Land';
};

export const getPropertyImageName = property => {
  const propertyType = property?.propertyType ? getPropertType(property?.propertyType) : property?.type;
  if (property?.isOffPlan) {
    return 'offplan_property.png';
  }
  switch (propertyType) {
    case 'Land':
      if (property?.constructionStatus) {
        if (property?.isVilla) {
          return 'villa_property.png';
        }
        if (property?.isBuilding) {
          return 'building_property.png';
        }
        return 'property_other.png';
      }
      return 'land_property.png';
    case 'Building':
      if (property?.isVilla) {
        return 'villa_property.png';
      }
      if (property?.isBuilding) {
        return 'building_property.png';
      }
      return 'property_other.png';
    case 'Unit':
      if (property?.isResidentialUnit) {
        if (property?.isVilla) {
          return 'villa_property.png';
        }
        if (property?.isBuilding) {
          return 'unit_property.png';
        }
      }
      if (property?.isCommercialUnit) {
        return 'commercial_property.png';
      }
      return 'property_other.png';
    default:
      return 'property_other.png';
  }
};

export const getMuncipality = id => {
  const MinicipalityMap = {
    1000: {
      en: 'Abu Dhabi City',
      ar: 'مدينة أبو ظبي',
    },
    1001: {
      en: 'Al Ain City',
      ar: 'مدينة العين',
    },
    1002: {
      en: 'Al Dhafra Region',
      ar: 'منطقة الظٝرة',
    },
  };

  return MinicipalityMap[id] || {};
};

export const getDistrict = id => {
  const district = filters.district.filter(dis => dis.value === id);
  return {
    ar: district[0]?.labelAr,
    en: district[0]?.labelEn,
  };
};

export const getCommunity = id => {
  const community = filters.community.filter(comm => comm.value === id);
  return {
    ar: community[0]?.labelAr,
    en: community[0]?.labelEn,
  };
};

export const getPropertyThumbnail = (type, action = 'lease') => {
  if (action === 'offPlan') {
    return offPlan;
  }
  if (type === PROPERTY_TYPE.LAND) {
    return landIcon;
  }
  if (type === PROPERTY_TYPE.UNIT) {
    if (action === 'lease') {
      return unitLeaseIcon;
    }
    return unitIcon;
  }
  return buildingIcon;
};

export const getTitle = (type, property) => {
  let title = '';

  if (type === 'Land') {
    title = property?.plotNumber + ', ' + property?.community + ', ' + property?.district;
  } else if (type === 'Unit') {
    title =
      (property?.unitReg || '') +
      ', ' +
      (property?.unitNumber || '') +
      ', ' +
      (property?.plotNumber || '') +
      ', ' +
      (property?.buildingNumber || '') +
      ', ' +
      (property?.community || '') +
      ', ' +
      (property?.muncipality || '');
  } else if (type === 'Building') {
    title = property?.plotID + ', ' + property?.buildingNumber + ', ' + property?.district;
  } else if (type === 'Villa') {
    title = property?.plotID + ', ' + property?.buildingNumber + ', ' + property?.district;
  } else {
    title = property?.plotNumber + ', ' + property?.community + ', ' + property?.district;
  }

  return title;
};

// Get property title without UNDEFINED
export const getPropertyTitle = (property, isMulti, propertiesList) => {
  const lang = localStorage.getItem('lang');
  const type = getPropertType(property?.propertyType);
  const isVilla = propertiesList?.[0]?.buildingClassificationEn?.toLowerCase() === 'villa';

  let district = property?.district || property?.districtEn || property?.districtNameEn;
  let muncipality = property?.municipalityNameEn || property?.muncipalityEn;
  let community =
    property?.community || property?.communityEn || property?.communityNameEn || property?.commUnityNameEn;
  if (lang === 'ar') {
    district = property?.district || property?.districtAr || property?.districtNameAr;
    community = property?.community || property?.communityAr || property?.communityNameAr || property?.commUnityNameAr;
    muncipality = property?.municipalityNameAr || property?.muncipalityAr;
  }

  let title = [];

  if (isMulti) {
    title = [
      ...(muncipality ? [muncipality] : ''),
      ...(district ? [district] : ''),
      ...(community ? [community] : ''),
      ...(property?.plotNumber ? [property?.plotNumber] : ''),
      ...(property?.buildingNumber && !isVilla ? [property?.buildingNumber] : ''),
    ];
    if (isVilla) {
      let buildingNums = [];
      buildingNums = propertiesList?.map(prop => prop?.buildingNumber);
      buildingNums?.length > 3 ? title.push([...buildingNums.slice(0, 3), '...']) : title.push(buildingNums);
    }
  } else {
    title = [
      ...(muncipality ? [muncipality] : ''),
      ...(district ? [district] : ''),
      ...(community ? [community] : ''),
      ...(property?.plotNumber ? [property?.plotNumber] : ''),
      ...(property?.buildingNumber ? [property?.buildingNumber] : ''),
      ...(property?.unitNumber && type !== 'Villa' ? [property?.unitNumber] : ''),
    ];
  }
  return title.join(', ');
};
export const locationTitle = (obj, lang) => {
  let title = [];
  if (lang === 'en') {
    title = [
      ...(obj?.municipalityNameEn || obj?.muncipalityEn || obj?.municipalityNameAr || obj?.muncipalityAr
        ? [obj?.municipalityNameEn || obj?.muncipalityEn || obj?.municipalityNameAr || obj?.muncipalityAr]
        : ''),
      ...(obj?.districtNameEn || obj?.districtEn || obj?.districtNameAr || obj?.districtAR
        ? [obj?.districtNameEn || obj?.districtEn || obj?.districtNameAr || obj?.districtAr]
        : ''),
      ...(obj?.communityNameEn || obj?.communityEn || obj?.communityNameAr || obj?.communityAr
        ? [obj?.communityNameEn || obj?.communityEn || obj?.communityNameAr || obj?.communityAr]
        : ''),
    ];
  } else {
    title = [
      ...(obj?.municipalityNameAr || obj?.muncipalityAr || obj?.municipalityNameEn || obj?.muncipalityEn
        ? [obj?.municipalityNameAr || obj?.muncipalityAr || obj?.municipalityNameEn || obj?.muncipalityEn]
        : ''),
      ...(obj?.districtNameAr || obj?.districtAr || obj?.districtNameEn || obj?.districtEn
        ? [obj?.districtNameAr || obj?.districtAr || obj?.districtNameEn || obj?.districtEn]
        : ''),
      ...(obj?.communityNameAr || obj?.communityAr || obj?.communityNameEn || obj?.communityEn
        ? [obj?.communityNameAr || obj?.communityAr || obj?.communityNameEn || obj?.communityEn]
        : ''),
    ];
  }
  return title.join(', ');
};
// Get fees paid buyer for sell & purchase
export const getFeePaidBy = paidBy => {
  switch (paidBy) {
    case 'SELLER_EXEMPT':
      return { en: 'Exempt seller (1%)', ar: 'البائع المعٝى (٪١)' };
    case 'BUYER_EXEMPT':
      return { en: 'Exempt buyer (1%)', ar: 'المشتري المعٝى (٪١)' };
    case 'BOTH_EXEMPT':
      return { en: 'Exempt both', ar: 'استثناء كليهما' };
    case 'BUYER_ONLY':
      return { en: 'Buyer only 2%', ar: 'المشتري ٪٢ ٝقط' };
    case 'SELLER_ONLY':
      return { en: 'Seller only 2%', ar: 'البائع ٪٢ ٝقط' };
    case 'SELLER_BUYER':
      return { en: 'Seller and buyer (1:1)', ar: 'البائع والمشتري (١:١)' };
    default:
      return { en: '', ar: '' };
  }
};

// Get formatted currency
export const formatCurrency = (amount, isAr = false) => {
  const formattedNumber = new Intl.NumberFormat('en-US', {
    minimumFractionDigits: 0,
  }).format(amount);

  if (isAr) {
    return `${formattedNumber} درهم`;
  }

  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'AED',
    minimumFractionDigits: 0,
  }).format(amount);
};

export const formatCurrencyWithoutCurrency = amount => {
  const Intelformat = new Intl.NumberFormat('en-US', {
    minimumFractionDigits: 0,
  }).format(amount);
  return Intelformat;
};
export const formatCurrencyWithoutCurrencyShortUnit = (amount, unit = 1) => {
  const Intelformat = new Intl.NumberFormat('en-US', {
    notation: 'compact',
    compactDisplay: 'short',
    maximumFractionDigits: unit,
  }).format(amount);
  return Intelformat;
};

// Number into Arabic
export const convertToArabicNumber = (num = 0) => {
  // const lang = 'en';
  // if (lang === 'en') {
  return num;
  // }
  // const arabicNumbers = '\u0660\u0661\u0662\u0663\u0664\u0665\u0666\u0667\u0668\u0669';
  // return new String(num).replace(/[0123456789]/g, d => {
  //   return arabicNumbers[d];
  // });
};

// Check if the number is valid Latitude
export const isLatitude = num => isFinite(num) && Math.abs(num) <= 90;

// Check if the number is valid Longitude
export const isLongitude = num => isFinite(num) && Math.abs(num) <= 180;

export const getLoggedInUserName = () => {
  const selectedAccount = JSON.parse(localStorage.getItem('selectedAccount'));
  const lang = localStorage.getItem('lang');
  const name = [];
  if (lang === 'en') {
    if (selectedAccount.firstNameEn) {
      name.push(selectedAccount.firstNameEn);
    }
    if (selectedAccount.lastNameEn) name.push(selectedAccount.lastNameEn);
  }
  if (lang === 'ar') {
    if (selectedAccount.firstNameAr) {
      name.push(selectedAccount.firstNameAr);
    }
    if (selectedAccount.lastNameAr) name.push(selectedAccount.lastNameAr);
  }
  // const name = `${lang === 'en' ? selectedAccount.firstNameEn : selectedAccount.firstNameAr} ${
  //   lang === 'en' ? selectedAccount.lastNameEn : selectedAccount.lastNameAr
  // }`;
  return name.join(' ');
};

export const getFormattedEID = eid => {
  return eid && eid.length >= 15
    ? [eid.slice(0, 3), '-', eid.slice(3, 7), '-', eid.slice(7, 14), '-', eid.slice(14)].join('')
    : eid;
};

export const convertNumberInWords = number => {
  const special = [
    'zeroth',
    'first',
    'second',
    'third',
    'fourth',
    'fifth',
    'sixth',
    'seventh',
    'eighth',
    'ninth',
    'tenth',
    'eleventh',
    'twelfth',
    'thirteenth',
    'fourteenth',
    'fifteenth',
    'sixteenth',
    'seventeenth',
    'eighteenth',
    'nineteenth',
  ];
  const deca = ['twent', 'thirt', 'fourt', 'fift', 'sixt', 'sevent', 'eight', 'ninet'];
  if (number < 20) return special[number];
  if (number % 10 === 0) return deca[Math.floor(number / 10) - 2] + 'ieth';
  return deca[Math.floor(number / 10) - 2] + 'y ' + special[number % 10];
};

export const paidOptions = [
  {
    valueId: 1,
    value: 'SELLER',
    label: <FormattedMessage {...messages.current_musateh} />,
  },
  {
    valueId: 2,
    value: 'BUYER',
    label: <FormattedMessage {...messages.new_musateh} />,
  },
];

export const keyEmptyCheck = (key, values) => {
  if (messages[key]) {
    return <FormattedMessage {...messages[key]} {...(!isEmpty(values) && { values: { ...values } })} />;
  }

  return key;
};

export const allowOnlyEnglishNumberAndSpecial = str => {
  const regex = /^[^\u0600-\u06FF\u0660-\u0669]+$/;

  return regex.test(str);
};
export const allowOnlyArabicNumberAndSpecial = str => {
  const regex = /^[\u0600-\u06FF\u0660-\u0669\d\W_]+$/;

  return regex.test(str);
};
export const transformDropDownItems = (dataItems, labelName, valueName, secondaryLabelName) => {
  if (isArray(dataItems))
    return dataItems.map(item => ({
      label: item?.[labelName] || item?.[secondaryLabelName],
      value: item?.[valueName],
    }));
  return [];
};

export const getDropdownLabelFromValue = (dropdowns, value) => {
  const data = dropdowns.find(dropdown => dropdown.value === value);
  return (data && data?.label) || '';
};

export const PlainString = value => {
  if (value.toString().includes(',')) {
    return value.replaceAll(',', '');
  }
  return value;
};

export const fPhoneNumber = phoneNumber => {
  if (!phoneNumber) return null;
  const lang = localStorage.getItem('lang');

  if (lang !== 'ar') return phoneNumber;

  if (phoneNumber?.[0] === '+') return phoneNumber?.slice(1) + '+';

  if (phoneNumber?.includes('*')) {
    const hidden = phoneNumber?.slice(0, phoneNumber?.lastIndexOf('*'));

    return phoneNumber?.slice(phoneNumber?.lastIndexOf('*')) + hidden;
  }

  return phoneNumber;
};

export const getAmountInWords = amount => {
  if (!amount) return '';
  const lang = localStorage.getItem('lang');
  const amountInWords = `${writtenNumber(amount, { lang })} ${lang === 'en' ? 'dirham' : 'درهم'}`;
  return lang === 'en' && amountInWords?.length > 0
    ? amountInWords[0].toUpperCase() + amountInWords.slice(1).replace(/-/g, ' ')
    : amountInWords;
};

export const fortmatDates = date => {
  if (['~', '-', 0, null, undefined].includes(date)) return '-';
  return format(new Date(date), 'dd/MM/yyyy');
};
export const taskHandler = item => {
  const tasksMap = {
    // ................ DMT
    DMT_REJECT: {
      OFFPLAN_PROJECT_REGISTRATION: `/app/applications/offplan-project-registration/post-returns/${item.applicationId}`,
      LEASE_REGISTRATION: '/app/applications/lease/owner-review',
      LEASE_RENEWAL: '/app/applications/lease/owner-review',
      LEASE_AMENDMENT: '/app/applications/lease/owner-review',
      LEASE_CLOSURE: '/app/services/lease-expiration',
      LEASE_TERMINATION_COURT_ORDER: '/app/services/lease-termination-court-order',
      WAIVER_MUSATAHA: `/app/applications/waiver-musataha/owner-review/${item.applicationId}`,
      LONG_LEASE_TO_MUSATAHA: '/app/applications/musataha/owner-review',
      UPDATE_CUSTOMER_DATA: `/app/application/return/profession-registration/${item.applicationId}`,
      NATIONAL_HOUSING_MORTGAGE: `/app/applications/nhl-mortgage/post-returns/${item.applicationId}`,
      OFFPLAN_TO_COMPLETE_LAND: `/app/applications/transfer-offplan/post-returns/${item?.applicationId}`,
      OFFPLAN_TO_COMPLETE_UNIT: `/app/applications/transfer-offplan/post-returns/${item?.applicationId}`,
      ADD_COMPANY_EMPLOYEE: `/app/application/add-employee/post-returns/${item.applicationId}`,
      UPDATE_COMPANY: `/app/application/update-company/return/${item.applicationId}`,
      ADD_COMPANY: `/app/applications/register-company-account/post-returns/${item.applicationId}`,
      MORTGAGE_RELEASE: `/app/application/mortgage-release/return/${item.applicationId}`,
      DRC_REGISTRATION: `/app/applications/dispute-registration/post-returns/${item.applicationId}`,
      SERVICE_PROVIDERS_PAYMENT_APPROVAL: `/app/applications/escrow-service-provider-payment-approval/post-return/${item?.applicationId}`,
      SELL_PURCHASE_LAND: `/app/application/sell-purchase/post-returns/${item.applicationId}`,
      SELL_PURCHASE_UNIT: `/app/application/sell-purchase/post-returns/${item.applicationId}`,
      POA_TERMINATE: `/app/services/terminate-poa/${item.applicationId}`,
    },
    DMT_RETURN: {
      OFFPLAN_PROJECT_REGISTRATION: `/app/applications/offplan-project-registration/post-returns/${item.applicationId}`,
      OFF_PLAN_TERMINATION: `/app/applications/off-plan-termination/post-returns/${item.applicationId}`,
      LONG_LEASE_TO_MUSATAHA: '/app/applications/musataha/owner-review',
      INTERPERSONAL_MUSATAHA_CONTRACT: `/app/application/interpersonal-musataha-contract/return/${item.applicationId}`,
    },
    DMT_SURVEYOR_RETURN: {
      OFFPLAN_PROJECT_REGISTRATION: `/app/applications/offplan-project-registration/post-returns/${item.applicationId}`,
    },
    DMT_REJECT_MAKER: {
      OFFPLAN_TO_COMPLETE_LAND: `/app/applications/transfer-offplan/post-returns/${item?.applicationId}`,
      OFFPLAN_TO_COMPLETE_UNIT: `/app/applications/transfer-offplan/post-returns/${item?.applicationId}`,
    },
    DARI_VALUE_RETURN: {
      REQUEST_VALUATION_CERTIFICATE_LAND: `/app/application/request-valuation-certificate-land/post-returns/${item?.applicationId}`,
      REQUEST_VALUATION_CERTIFICATE_UNIT: `/app/application/valuation-certificate-unit/post-returns/${item?.applicationId}`,
    },

    // ................. APPROVALS
    MUSATAHA_APPROVAL: {
      INTERPERSONAL_MUSATAHA_CONTRACT: `/app/application/interpersonal-musataha-contract/post-approvals/${item.applicationId}`,
    },
    SIGNATORY_APPROVAL: {
      INTERPERSONAL_MUSATAHA_CONTRACT: `/app/application/interpersonal-musataha-contract/post-approvals/${item.applicationId}`,
    },
    SELLER_APPROVAL: {
      WAIVER_MUSATAHA: `/app/applications/waiver-musataha/seller-review/${item.applicationId}`,
      SELL_PURCHASE_LAND: `/app/application/sell-purchase/post-approvals/${item.applicationId}`,
      SELL_PURCHASE_UNIT: `/app/application/sell-purchase/post-approvals/${item.applicationId}`,
    },
    BUYER_APPROVAL: {
      WAIVER_MUSATAHA: `/app/applications/waiver-musataha/buyer-review/${item.applicationId}`,
      SELL_PURCHASE_LAND: `/app/application/sell-purchase/post-approvals/${item.applicationId}`,
      SELL_PURCHASE_UNIT: `/app/application/sell-purchase/post-approvals/${item.applicationId}`,
      OFFPLAN_TO_COMPLETE_LAND: `/app/applications/transfer-offplan/post-approvals/${item?.applicationId}`,
      OFFPLAN_TO_COMPLETE_UNIT: `/app/applications/transfer-offplan/post-approvals/${item?.applicationId}`,
      TRANSFER_OF_INTEREST_LAND: `/app/application/transfer-of-interest/post-approvals/${item.applicationId}`,
      TRANSFER_OF_INTEREST_UNIT: `/app/application/transfer-of-interest/post-approvals/${item.applicationId}`,
      DIGITAL_TRANSFER_OF_INTEREST_LAND: `/app/application/digital-transfer-of-interest/post-approvals/${item.applicationId}`,
      DIGITAL_TRANSFER_OF_INTEREST_UNIT: `/app/application/digital-transfer-of-interest/post-approvals/${item.applicationId}`,
      OFF_PLAN_TERMINATION: `/app/applications/off-plan-termination/post-approvals/${item.applicationId}`,
    },
    OWNER_FINAL_APPROVAL: {},
    TENANT_APPROVAL: {
      LONG_LEASE_TO_MUSATAHA: '/app/applications/musataha/tenant-review',
      LEASE_REGISTRATION: '/app/applications/lease/lessee-review',
      LEASE_CANCELLATION: '/app/applications/lease/lessee-review',
      LEASE_AMENDMENT: '/app/applications/lease/lessee-review',
      LEASE_RENEWAL: '/app/applications/lease/lessee-review',
      LEASE_CLOSURE: '/app/applications/lease/lessee-review',
      LEASE_TERMINATION_COURT_ORDER: '/app/applications/lease/lessee-review',
    },
    OWNER_APPROVAL: {
      INTERPERSONAL_MUSATAHA_CONTRACT: `/app/application/interpersonal-musataha-contract/post-approvals/${item.applicationId}`,
      MORTGAGE_REGISTRATION_LAND: `/app/applications/mortgage/post-approvals/${item.applicationId}`,
      MORTGAGE_REGISTRATION_UNIT: `/app/applications/mortgage/post-approvals/${item.applicationId}`,
      MORTGAGE_MODIFICATION: `/app/application/mortgage-modification/post-approvals/${item.applicationId}`,
      NATIONAL_HOUSING_MORTGAGE: `/app/applications/nhl-mortgage/post-approvals/${item.applicationId}`,
      PMA_REGISTRATION: `/app/applications/pma/post-approvals/${item?.applicationId}`,
      PMA_RENEWAL: `/app/applications/pma/post-approvals/${item?.applicationId}`,
      PMA_AMENDMENT: `/app/applications/pma/post-approvals/${item?.applicationId}`,
      PMA_CANCELLATION: `/app/applications/pma/post-approvals/${item?.applicationId}`,
      MORTGAGE_RELEASE: `/app/application/mortgage-release/review/${item.applicationId}`,
      SELL_PURCHASE_LAND: `/app/application/sell-purchase/post-approvals/${item.applicationId}`,
      SELL_PURCHASE_UNIT: `/app/application/sell-purchase/post-approvals/${item.applicationId}`,
      LEASE_REGISTRATION: '/app/applications/lease/lessee-review',
      LEASE_CANCELLATION: '/app/applications/lease/lessee-review',
      LEASE_AMENDMENT: '/app/applications/lease/lessee-review',
      LEASE_RENEWAL: '/app/applications/lease/lessee-review',
      LEASE_CLOSURE: '/app/applications/lease/lessee-review',
      LEASE_TERMINATION_COURT_ORDER: '/app/applications/lease/lessee-review',
      TRANSFER_OF_INTEREST_LAND: `/app/application/transfer-of-interest/post-approvals/${item.applicationId}`,
      TRANSFER_OF_INTEREST_UNIT: `/app/application/transfer-of-interest/post-approvals/${item.applicationId}`,
      DIGITAL_TRANSFER_OF_INTEREST_LAND: `/app/application/digital-transfer-of-interest/post-approvals/${item.applicationId}`,
      DIGITAL_TRANSFER_OF_INTEREST_UNIT: `/app/application/digital-transfer-of-interest/post-approvals/${item.applicationId}`,
      PERMIT_ADVERTISEMENT_BROKER_LAND: `/app/application/request-permit-advertisement/post-approvals/${item?.applicationId}`,
      PERMIT_ADVERTISEMENT_BROKER_UNIT: `/app/application/request-permit-advertisement/post-approvals/${item?.applicationId}`,
    },
    DEVELOPER_APPROVAL: {
      OFFPLAN_PROJECT_REGISTRATION: `/app/applications/offplan-project-registration/post-approvals/${item.applicationId}`,
      OFF_PLAN_TERMINATION: `/app/applications/off-plan-termination/post-approvals/${item.applicationId}`,
      ESCROW_ACCOUNT_REGISTRATION: `/app/applications/escrow-account-registration/${item?.applicationId}`,
      OFFPLAN_TO_COMPLETE_LAND: `/app/applications/transfer-offplan/post-approvals/${item?.applicationId}`,
      OFFPLAN_TO_COMPLETE_UNIT: `/app/applications/transfer-offplan/post-approvals/${item?.applicationId}`,
      SERVICE_PROVIDERS_PAYMENT_APPROVAL: `/app/applications/escrow-service-provider-payment-approval/${item?.applicationId}`,
      OFF_PLAN_FIRST_SELL_LAND: `/app/applications/offplan-buy-sell/post-approvals/${item?.applicationId}`,
      OFF_PLAN_FIRST_SELL_UNIT: `/app/applications/offplan-buy-sell/post-approvals/${item?.applicationId}`,
      OFFPLAN_TERMINATION_LEGAL_NOTICE: `/app/application/legal-notice/post-approvals/${item.applicationId}`,
      PERMIT_ADVERTISEMENT_BROKER_LAND: `/app/application/request-permit-advertisement/post-approvals/${item?.applicationId}`,
      PERMIT_ADVERTISEMENT_BROKER_UNIT: `/app/application/request-permit-advertisement/post-approvals/${item?.applicationId}`,
    },
    COMPANY_ADMIN_APPROVAL: {
      ADD_COMPANY_EMPLOYEE: `/app/application/add-employee/post-approvals/${item.applicationId}`,
    },
    BANK_SIGNATORY_APPROVAL: {
      ESCROW_ACCOUNT_REGISTRATION: `/app/applications/escrow-account-registration/${item?.applicationId}`,
    },
    DEVELOPER_SIGNATORY_APPROVAL: {
      ESCROW_ACCOUNT_REGISTRATION: `/app/applications/escrow-account-registration/${item?.applicationId}`,
    },
    BANK_APPROVAL: {
      PMA_CANCELLATION: `/app/applications/pma/post-approvals/${item?.applicationId}`,
      PMA_REGISTRATION: `/app/applications/pma/post-approvals/${item?.applicationId}`,
      PMA_RENEWAL: `/app/applications/pma/post-approvals/${item?.applicationId}`,
      PMA_AMENDMENT: `/app/applications/pma/post-approvals/${item?.applicationId}`,
    },
    // ................ RETURNS
    MUSATAHA_RETURN: {
      INTERPERSONAL_MUSATAHA_CONTRACT: `/app/application/interpersonal-musataha-contract/return/${item.applicationId}`,
    },
    BUYER_RETURN: {
      WAIVER_MUSATAHA: `/app/applications/waiver-musataha/owner-review/${item.applicationId}`,
      OFFPLAN_TO_COMPLETE_LAND: `/app/applications/transfer-offplan/post-returns/${item?.applicationId}`,
      OFFPLAN_TO_COMPLETE_UNIT: `/app/applications/transfer-offplan/post-returns/${item?.applicationId}`,
      SELL_PURCHASE_LAND: `/app/application/sell-purchase/post-returns/${item.applicationId}`,
      SELL_PURCHASE_UNIT: `/app/application/sell-purchase/post-returns/${item.applicationId}`,
      TRANSFER_OF_INTEREST_LAND: `/app/application/transfer-of-interest/post-returns/${item.applicationId}`,
      TRANSFER_OF_INTEREST_UNIT: `/app/application/transfer-of-interest/post-returns/${item.applicationId}`,
      DIGITAL_TRANSFER_OF_INTEREST_LAND: `/app/application/digital-transfer-of-interest/post-returns/${item.applicationId}`,
      DIGITAL_TRANSFER_OF_INTEREST_UNIT: `/app/application/digital-transfer-of-interest/post-returns/${item.applicationId}`,
      OFF_PLAN_TERMINATION: `/app/applications/off-plan-termination/post-returns/${item.applicationId}`,
    },
    OWNER_RETURN: {
      INTERPERSONAL_MUSATAHA_CONTRACT: `/app/application/interpersonal-musataha-contract/return/${item.applicationId}`,
      MORTGAGE_REGISTRATION_LAND: `/app/applications/mortgage/post-returns/${item.applicationId}`,
      MORTGAGE_REGISTRATION_UNIT: `/app/applications/mortgage/post-returns/${item.applicationId}`,
      MORTGAGE_MODIFICATION: `/app/application/mortgage-modification/post-returns/${item.applicationId}`,
      PMA_REGISTRATION: `/app/applications/pma/post-approvals/${item?.applicationId}`,
      PMA_RENEWAL: `/app/applications/pma/post-approvals/${item?.applicationId}`,
      PMA_AMENDMENT: `/app/applications/pma/post-approvals/${item?.applicationId}`,
      PMA_CANCELLATION: `/app/applications/pma/post-approvals/${item?.applicationId}`,
      NATIONAL_HOUSING_MORTGAGE: `/app/applications/nhl-mortgage/post-returns/${item.applicationId}`,
      MORTGAGE_RELEASE: `/app/application/mortgage-release/return/${item.applicationId}`,
      LEASE_REGISTRATION: '/app/applications/lease/owner-review',
      LEASE_CANCELLATION: '/app/applications/lease/owner-review',
      LEASE_AMENDMENT: '/app/applications/lease/owner-review',
      LEASE_RENEWAL: '/app/applications/lease/owner-review',
      LEASE_CLOSURE: '/app/applications/lease/owner-review',
      LEASE_TERMINATION_COURT_ORDER: '/app/applications/lease/owner-review',
      TRANSFER_OF_INTEREST_LAND: `/app/application/transfer-of-interest/post-returns/${item.applicationId}`,
      TRANSFER_OF_INTEREST_UNIT: `/app/application/transfer-of-interest/post-returns/${item.applicationId}`,
      DIGITAL_TRANSFER_OF_INTEREST_LAND: `/app/application/digital-transfer-of-interest/post-returns/${item.applicationId}`,
      DIGITAL_TRANSFER_OF_INTEREST_UNIT: `/app/application/digital-transfer-of-interest/post-returns/${item.applicationId}`,
      PERMIT_ADVERTISEMENT_BROKER_LAND: `/app/application/request-permit-advertisement/post-returns/${item?.applicationId}`,
      PERMIT_ADVERTISEMENT_BROKER_UNIT: `/app/application/request-permit-advertisement/post-returns/${item?.applicationId}`,
    },
    TENANT_RETURN: {
      LONG_LEASE_TO_MUSATAHA: '/app/applications/musataha/owner-review',
      LEASE_REGISTRATION: '/app/applications/lease/owner-review',
      LEASE_CANCELLATION: '/app/applications/lease/owner-review',
      LEASE_AMENDMENT: '/app/applications/lease/owner-review',
      LEASE_RENEWAL: '/app/applications/lease/owner-review',
      LEASE_CLOSURE: '/app/applications/lease/owner-review',
      LEASE_TERMINATION_COURT_ORDER: '/app/applications/lease/owner-review',
    },
    MAKER_RETURN: {
      MORTGAGE_REGISTRATION_LAND: `/app/applications/mortgage/post-returns/${item.applicationId}`,
      MORTGAGE_REGISTRATION_UNIT: `/app/applications/mortgage/post-returns/${item.applicationId}`,
      ESCROW_ACCOUNT_REGISTRATION: `/app/applications/escrow-account-registration/${item?.applicationId}`,
      NATIONAL_HOUSING_MORTGAGE: `/app/applications/nhl-mortgage/post-returns/${item.applicationId}`,
      OFFPLAN_TO_COMPLETE_LAND: `/app/applications/transfer-offplan/post-returns/${item?.applicationId}`,
      OFFPLAN_TO_COMPLETE_UNIT: `/app/applications/transfer-offplan/post-returns/${item?.applicationId}`,
      MORTGAGE_RELEASE: `/app/application/mortgage-release/return/${item.applicationId}`,
      MORTGAGE_MODIFICATION: `/app/application/mortgage-modification/post-returns/${item.applicationId}`,
      TRANSFER_OF_INTEREST_LAND: `/app/application/transfer-of-interest/post-returns/${item.applicationId}`,
      TRANSFER_OF_INTEREST_UNIT: `/app/application/transfer-of-interest/post-returns/${item.applicationId}`,
      SERVICE_PROVIDERS_PAYMENT_APPROVAL: `/app/applications/escrow-service-provider-payment-approval/post-return/${item?.applicationId}`,
      DIGITAL_TRANSFER_OF_INTEREST_LAND: `/app/application/digital-transfer-of-interest/post-returns/${item.applicationId}`,
      DIGITAL_TRANSFER_OF_INTEREST_UNIT: `/app/application/digital-transfer-of-interest/post-returns/${item.applicationId}`,
      OFF_PLAN_TERMINATION: `/app/applications/off-plan-termination/post-returns/${item.applicationId}`,
    },
    ADGM_REVIEW: {
      OFF_PLAN_TERMINATION: `/app/applications/off-plan-termination/post-returns/${item.applicationId}`,
    },
    ADGM_RETURN: {
      LEASE_REGISTRATION: '/app/applications/lease/owner-review',
      LEASE_CANCELLATION: '/app/applications/lease/owner-review',
      LEASE_AMENDMENT: '/app/applications/lease/owner-review',
      LEASE_RENEWAL: '/app/applications/lease/owner-review',
      LEASE_CLOSURE: '/app/applications/lease/owner-review',
      LEASE_TERMINATION_COURT_ORDER: '/app/services/lease-termination-court-order',
      ADD_COMPANY_EMPLOYEE: `/app/application/add-employee/post-returns/${item.applicationId}`,
      UPDATE_COMPANY: `/app/application/update-company/return/${item.applicationId}`,
      PROFILE_CREATION: `/app/application/profile-creation/post-returns/${item.applicationId}`,
      OFF_PLAN_FIRST_SELL_LAND: `/app/applications/offplan-buy-sell/post-returns/${item.applicationId}`,
      OFF_PLAN_FIRST_SELL_UNIT: `/app/applications/offplan-buy-sell/post-returns/${item.applicationId}`,
      ADD_COMPANY: `/app/applications/register-company-account/post-returns/${item?.applicationId}`,
      TRANSFER_OF_INTEREST_LAND: `/app/application/transfer-of-interest/post-returns/${item.applicationId}`,
      TRANSFER_OF_INTEREST_UNIT: `/app/application/transfer-of-interest/post-returns/${item.applicationId}`,
      DIGITAL_TRANSFER_OF_INTEREST_LAND: `/app/application/digital-transfer-of-interest/post-returns/${item.applicationId}`,
      DIGITAL_TRANSFER_OF_INTEREST_UNIT: `/app/application/digital-transfer-of-interest/post-returns/${item.applicationId}`,
      ADD_POA: `/app/applications/add-poa/post-return/${item?.applicationId}`,
      CERT_TITLE_DEED_UNIT: `/app/application/certificates/${item?.applicationType}/${item.applicationId}`,
      CERT_TITLE_DEED_PLOT: `/app/application/certificates/${item?.applicationType}/${item.applicationId}`,
      CERT_VERIFICATION_UNIT: `/app/application/certificates/${item?.applicationType}/${item.applicationId}`,
      CERT_VERIFICATION_PLOT: `/app/application/certificates/${item?.applicationType}/${item.applicationId}`,
      CERT_SITE_PLAN_PLOT: `/app/application/certificates/${item?.applicationType}/${item.applicationId}`,
      CERT_PROP_OWNERSHIP: `/app/application/certificates/${item?.applicationType}/${item.applicationId}`,
      MORTGAGE_REGISTRATION_LAND: `/app/applications/mortgage/post-returns/${item.applicationId}`,
      MORTGAGE_REGISTRATION_UNIT: `/app/applications/mortgage/post-returns/${item.applicationId}`,
      MORTGAGE_MODIFICATION: `/app/application/mortgage-modification/post-returns/${item.applicationId}`,
      MORTGAGE_RELEASE: `/app/application/mortgage-release/return/${item.applicationId}`,
      OFF_PLAN_TERMINATION: `/app/applications/off-plan-termination/post-returns/${item.applicationId}`,
    },

    RETURNED: {
      PROFILE_CREATION: `/app/application/profile-creation/post-returns/${item.applicationId}`,
      ADD_POA: `/app/applications/add-poa/post-return/${item?.applicationId}`,
      OFF_PLAN_TERMINATION: `/app/applications/off-plan-termination/post-returns/${item.applicationId}`,
    },
    SURVEYING_CONSULTANT_REVIEW: {
      OFFPLAN_PROJECT_REGISTRATION: `/app/applications/offplan-project-registration/post-approvals/${item.applicationId}`,
    },
    SURVEYING_CONSULTANT_RETURN: {
      OFFPLAN_PROJECT_REGISTRATION: `/app/applications/offplan-project-registration/post-returns/${item.applicationId}`,
    },
    COMPANY_ADMIN_RETURN: {
      ADD_COMPANY_EMPLOYEE: `/app/application/add-employee/post-returns/${item.applicationId}`,
    },
    CHECKER_RETURN: {
      MORTGAGE_REGISTRATION_LAND: `/app/applications/mortgage/post-returns/${item.applicationId}`,
      MORTGAGE_REGISTRATION_UNIT: `/app/applications/mortgage/post-returns/${item.applicationId}`,
      MORTGAGE_MODIFICATION: `/app/application/mortgage-modification/post-returns/${item.applicationId}`,
      ESCROW_ACCOUNT_REGISTRATION: `/app/applications/escrow-account-registration/${item?.applicationId}`,
      NATIONAL_HOUSING_MORTGAGE: `/app/applications/nhl-mortgage/post-returns/${item.applicationId}`,
      OFFPLAN_TO_COMPLETE_LAND: `/app/applications/transfer-offplan/post-returns/${item?.applicationId}`,
      OFFPLAN_TO_COMPLETE_UNIT: `/app/applications/transfer-offplan/post-returns/${item?.applicationId}`,
      MORTGAGE_RELEASE: `/app/application/mortgage-release/return/${item.applicationId}`,
      SERVICE_PROVIDERS_PAYMENT_APPROVAL: `/app/applications/escrow-service-provider-payment-approval/post-return/${item?.applicationId}`,
      DIGITAL_TRANSFER_OF_INTEREST_LAND: `/app/application/digital-transfer-of-interest/post-returns/${item.applicationId}`,
      DIGITAL_TRANSFER_OF_INTEREST_UNIT: `/app/application/digital-transfer-of-interest/post-returns/${item.applicationId}`,
      TRANSFER_OF_INTEREST_LAND: `/app/application/transfer-of-interest/post-returns/${item.applicationId}`,
      TRANSFER_OF_INTEREST_UNIT: `/app/application/transfer-of-interest/post-returns/${item.applicationId}`,
      OFF_PLAN_TERMINATION: `/app/applications/off-plan-termination/post-returns/${item.applicationId}`,
    },
    DEVELOPER_RETURN: {
      OFFPLAN_PROJECT_REGISTRATION: `/app/applications/offplan-project-registration/post-returns/${item.applicationId}`,
      OFF_PLAN_TERMINATION: `/app/applications/off-plan-termination/post-returns/${item.applicationId}`,
      ESCROW_ACCOUNT_REGISTRATION: `/app/applications/escrow-account-registration/${item?.applicationId}`,
      OFFPLAN_TO_COMPLETE_LAND: `/app/applications/transfer-offplan/post-returns/${item?.applicationId}`,
      OFFPLAN_TO_COMPLETE_UNIT: `/app/applications/transfer-offplan/post-returns/${item?.applicationId}`,
      SERVICE_PROVIDERS_PAYMENT_APPROVAL: `/app/applications/escrow-service-provider-payment-approval/post-return/${item?.applicationId}`,
      OFF_PLAN_FIRST_SELL_LAND: `/app/applications/offplan-buy-sell/post-returns/${item.applicationId}`,
      OFF_PLAN_FIRST_SELL_UNIT: `/app/applications/offplan-buy-sell/post-returns/${item.applicationId}`,
      OFFPLAN_TERMINATION_LEGAL_NOTICE: `/app/application/legal-notice/post-returns/${item.applicationId}`,
      PERMIT_ADVERTISEMENT_BROKER_LAND: `/app/application/request-permit-advertisement/post-returns/${item?.applicationId}`,
      PERMIT_ADVERTISEMENT_BROKER_UNIT: `/app/application/request-permit-advertisement/post-returns/${item?.applicationId}`,
    },
    SELLER_RETURN: {
      SELL_PURCHASE_LAND: `/app/application/sell-purchase/post-returns/${item.applicationId}`,
      SELL_PURCHASE_UNIT: `/app/application/sell-purchase/post-returns/${item.applicationId}`,
      INTERPERSONAL_MUSATAHA_CONTRACT: `/app/application/interpersonal-musataha-contract/return/${item.applicationId}`,
      WAIVER_MUSATAHA: `/app/applications/waiver-musataha/owner-review/${item.applicationId}`,
    },
    PMC_SIGNATORY_RETURN: {
      PMA_REGISTRATION: `/app/applications/pma/post-approvals/${item?.applicationId}`,
      PMA_CANCELLATION: `/app/applications/pma/post-approvals/${item?.applicationId}`,
      PMA_RENEWAL: `/app/applications/pma/post-approvals/${item?.applicationId}`,
      PMA_AMENDMENT: `/app/applications/pma/post-approvals/${item?.applicationId}`,
    },
    PMC_SIGNATORY_APPROVAL: {
      PMA_REGISTRATION: `/app/applications/pma/post-approvals/${item?.applicationId}`,
      PMA_CANCELLATION: `/app/applications/pma/post-approvals/${item?.applicationId}`,
      PMA_RENEWAL: `/app/applications/pma/post-approvals/${item?.applicationId}`,
      PMA_AMENDMENT: `/app/applications/pma/post-approvals/${item?.applicationId}`,
    },
    BANK_RETURN: {
      PMA_REGISTRATION: `/app/applications/pma/post-approvals/${item?.applicationId}`,
      PMA_CANCELLATION: `/app/applications/pma/post-approvals/${item?.applicationId}`,
      PMA_RENEWAL: `/app/applications/pma/post-approvals/${item?.applicationId}`,
      PMA_AMENDMENT: `/app/applications/pma/post-approvals/${item?.applicationId}`,
    },

    // ................ REVIEWS
    MAKER_REVIEW: {
      MORTGAGE_REGISTRATION_LAND: `/app/applications/mortgage/post-approvals/${item.applicationId}`,
      MORTGAGE_REGISTRATION_UNIT: `/app/applications/mortgage/post-approvals/${item.applicationId}`,
      DIGITAL_TRANSFER_OF_INTEREST_LAND: `/app/application/digital-transfer-of-interest/post-approvals/${item.applicationId}`,
      DIGITAL_TRANSFER_OF_INTEREST_UNIT: `/app/application/digital-transfer-of-interest/post-approvals/${item.applicationId}`,
      ESCROW_ACCOUNT_REGISTRATION: `/app/applications/escrow-account-registration/${item?.applicationId}`,
      NATIONAL_HOUSING_MORTGAGE: `/app/applications/nhl-mortgage/post-approvals/${item.applicationId}`,
      OFFPLAN_TO_COMPLETE_LAND: `/app/applications/transfer-offplan/post-approvals/${item?.applicationId}`,
      OFFPLAN_TO_COMPLETE_UNIT: `/app/applications/transfer-offplan/post-approvals/${item?.applicationId}`,
      MORTGAGE_MODIFICATION: `/app/application/mortgage-modification/post-approvals/${item.applicationId}`,
      MORTGAGE_RELEASE: `/app/application/mortgage-release/review/${item.applicationId}`,
      SERVICE_PROVIDERS_PAYMENT_APPROVAL: `/app/applications/escrow-service-provider-payment-approval/${item?.applicationId}`,
      TRANSFER_OF_INTEREST_LAND: `/app/application/transfer-of-interest/post-approvals/${item.applicationId}`,
      TRANSFER_OF_INTEREST_UNIT: `/app/application/transfer-of-interest/post-approvals/${item.applicationId}`,
      OFF_PLAN_TERMINATION: `/app/applications/off-plan-termination/post-approvals/${item.applicationId}`,
    },
    BUYER_REVIEW: {
      TRANSFER_OF_INTEREST_LAND: `/app/application/transfer-of-interest/post-approvals/${item.applicationId}`,
      TRANSFER_OF_INTEREST_UNIT: `/app/application/transfer-of-interest/post-approvals/${item.applicationId}`,
      OFF_PLAN_TERMINATION: `/app/applications/off-plan-termination/post-approvals/${item.applicationId}`,
    },
    CHECKER_REVIEW: {
      DIGITAL_TRANSFER_OF_INTEREST_LAND: `/app/application/digital-transfer-of-interest/post-approvals/${item.applicationId}`,
      DIGITAL_TRANSFER_OF_INTEREST_UNIT: `/app/application/digital-transfer-of-interest/post-approvals/${item.applicationId}`,
      MORTGAGE_REGISTRATION_LAND: `/app/applications/mortgage/post-approvals/${item.applicationId}`,
      MORTGAGE_REGISTRATION_UNIT: `/app/applications/mortgage/post-approvals/${item.applicationId}`,
      ESCROW_ACCOUNT_REGISTRATION: `/app/applications/escrow-account-registration/${item?.applicationId}`,
      NATIONAL_HOUSING_MORTGAGE: `/app/applications/nhl-mortgage/post-approvals/${item.applicationId}`,
      OFFPLAN_TO_COMPLETE_LAND: `/app/applications/transfer-offplan/post-approvals/${item?.applicationId}`,
      OFFPLAN_TO_COMPLETE_UNIT: `/app/applications/transfer-offplan/post-approvals/${item?.applicationId}`,
      MORTGAGE_MODIFICATION: `/app/application/mortgage-modification/post-approvals/${item.applicationId}`,
      MORTGAGE_RELEASE: `/app/application/mortgage-release/review/${item.applicationId}`,
      SERVICE_PROVIDERS_PAYMENT_APPROVAL: `/app/applications/escrow-service-provider-payment-approval/${item?.applicationId}`,
      TRANSFER_OF_INTEREST_LAND: `/app/application/transfer-of-interest/post-approvals/${item.applicationId}`,
      TRANSFER_OF_INTEREST_UNIT: `/app/application/transfer-of-interest/post-approvals/${item.applicationId}`,
      OFF_PLAN_TERMINATION: `/app/applications/off-plan-termination/post-approvals/${item.applicationId}`,
    },

    // ................ REJECTS
    SELLER_REJECT: {
      SELL_PURCHASE_LAND: `/app/application/sell-purchase/post-returns/${item.applicationId}`,
      SELL_PURCHASE_UNIT: `/app/application/sell-purchase/post-returns/${item.applicationId}`,
    },
    OWNER_REJECT: {},
    TENANT_REJECT: {},
    LEASE_TENANT_REJECT: '/app/applications/lease/owner-review',
    LEASE_OWNER_REJECT: '/app/applications/lease/owner-review',
    DEVELOPER_REJECT: {
      OFFPLAN_PROJECT_REGISTRATION: `/app/applications/offplan-project-registration/post-returns/${item.applicationId}`,
      OFF_PLAN_TERMINATION: `/app/applications/off-plan-termination/post-returns/${item.applicationId}`,
    },
    COMPANY_ADMIN_REJECT: {},

    // ................ PAYMENTS
    DARI_PENDING_PAYMENT: {
      OFFPLAN_PROJECT_REGISTRATION: `/app/applications/offplan-project-registration/payment/${item.applicationId}`,
      LONG_LEASE_TO_MUSATAHA: `/app/applications/musataha/payment/${item.applicationId}`,
      ESCROW_ACCOUNT_REGISTRATION: `/app/applications/escrow-account-registration/payment/${item?.applicationId}`,
      WAIVER_MUSATAHA: `/app/applications/waiver-musataha/payment/${item.applicationId}`,
      RENT_FEE_COLLECTION: `/app/applications/rent-payment/payment/${item.applicationId}`,
      OFF_PLAN_FIRST_SELL_LAND: `/app/applications/offplan-buy-sell/payment/${item.applicationId}`,
      OFF_PLAN_FIRST_SELL_UNIT: `/app/applications/offplan-buy-sell/payment/${item.applicationId}`,
      PMA_REGISTRATION: `/app/applications/pma/payment/${item.applicationId}`,
      PMA_AMENDMENT: `/app/applications/pma/payment/${item.applicationId}`,
      PMA_RENEWAL: `/app/applications/pma/payment/${item.applicationId}`,
      NATIONAL_HOUSING_MORTGAGE: `/app/applications/nhl-mortgage/payment/${item?.applicationId}`,
      OFFPLAN_TO_COMPLETE_LAND: `/app/applications/transfer-offplan/payment/${item?.applicationId}`,
      OFFPLAN_TO_COMPLETE_UNIT: `/app/applications/transfer-offplan/payment/${item?.applicationId}`,
      REQUEST_LICENCE_BROKER_COMPANY: `/app/application/detail/license-registration/payment/${item.applicationId}`,
      REQUEST_LICENCE_PRIMARY_DEVELOPER: `/app/application/detail/license-registration/payment/${item.applicationId}`,
      REQUEST_VALUATION_CERTIFICATE_LAND: `/app/services/request-valuation-certificate-land/payment/${item?.applicationId}`,
      REQUEST_VALUATION_CERTIFICATE_UNIT: `/app/services/request-valuation-certificate-unit/payment/${item?.applicationId}`,
      DRC_EXPERT_OPINION: `/app/applications/request-expert-opinion/payment/${item?.applicationId}`,
      INTERPERSONAL_MUSATAHA_CONTRACT: `/app/application/interpersonal-musataha-contract/payment/${item.applicationId}`,
    },
    // ................ CONTRACTS & CERTIFICATES
    GET_CERTIFICATE: {
      REQUEST_LICENCE_BROKER_INDIVIDUAL: `/app/application/detail/broker-individual/${item?.applicationId}`,
      REQUEST_LICENCE_BROKER_EMPLOYEE: `/app/application/detail/broker-employee/${item?.applicationId}`,
      REQUEST_LICENCE_BROKER_COMPANY: `/app/application/detail/broker-company/${item?.applicationId}`,
      REQUEST_LICENCE_PRIMARY_DEVELOPER: `/app/application/detail/primary-developer/${item?.applicationId}`,
      REQUEST_LICENCE_SECONDARY_DEVELOPER: `/app/application/detail/secondary-developer/${item?.applicationId}`,
      REQUEST_LICENCE_ACCOUNT_TRUSTEE: `/app/application/detail/account-trustee/${item?.applicationId}`,
      REQUEST_LICENCE_AUCTIONEER_COMPANY: `/app/application/detail/auctioneer-company/${item?.applicationId}`,
      REQUEST_LICENCE_SURVEYOR_COMPANY: `/app/application/detail/surveyor-company/${item?.applicationId}`,
      REQUEST_LICENCE_SURVEYOR_EMPLOYEE: `/app/application/detail/surveyor-employee/${item?.applicationId}`,
      REQUEST_LICENCE_AUCTIONEER_EMPLOYEE: `/app/application/detail/auctioneer-employee/${item?.applicationId}`,
      REQUEST_LICENCE_EVALUATOR_COMPANY: `/app/application/detail/evaluator-company/${item?.applicationId}`,
      REQUEST_LICENCE_EVALUATOR_EMPLOYEE: `/app/application/detail/evaluator-employee/${item?.applicationId}`,
      default: '/app/services/certificate-success',
    },
    GENERATE_CERTIFICATE: {
      OFFPLAN_PROJECT_REGISTRATION: '/app/services/offplan-project-registration/application/success',
      OFF_PLAN_TERMINATION: '/app/services/off-plan-termination/application/success',
      MORTGAGE_REGISTRATION_LAND: `/app/services/mortgage/application/success`,
      MORTGAGE_REGISTRATION_UNIT: `/app/services/mortgage/application/success`,
      NATIONAL_HOUSING_MORTGAGE: '/app/services/nhl-mortgage/application/success',
      OFFPLAN_TO_COMPLETE_LAND: '/app/services/offplan-to-complete/application/success',
      OFFPLAN_TO_COMPLETE_UNIT: '/app/services/offplan-to-complete/application/success',
      MORTGAGE_MODIFICATION: '/app/services/mortgage-modification/applications/success',
    },
    DOWNLOAD_CONTRACT: {
      OFFPLAN_PROJECT_REGISTRATION: '/app/services/offplan-project-registration/application/success',
      OFF_PLAN_TERMINATION: '/app/services/off-plan-termination/application/success',
      MORTGAGE_REGISTRATION_LAND: `/app/services/mortgage/application/success`,
      MORTGAGE_REGISTRATION_UNIT: `/app/services/mortgage/application/success`,
      WAIVER_MUSATAHA: `/app/applications/waiver-musataha/final-success/${item?.applicationId}`,
      LONG_LEASE_TO_MUSATAHA: `/app/applications/musataha/final-success/${item?.applicationId}`,
      OFF_PLAN_FIRST_SELL_LAND: '/app/services/offplan-buy-sell/application/success',
      OFF_PLAN_FIRST_SELL_UNIT: '/app/services/offplan-buy-sell/application/success',
      ESCROW_ACCOUNT_REGISTRATION: '/app/services/escrow-account-registration/application/success',
      SERVICE_PROVIDERS_PAYMENT_APPROVAL: '/app/services/escrow-service-provider-payment-approval/application/success',
      NATIONAL_HOUSING_MORTGAGE: '/app/services/nhl-mortgage/application/success',
      OFFPLAN_TO_COMPLETE_LAND: '/app/services/offplan-to-complete/application/success',
      OFFPLAN_TO_COMPLETE_UNIT: '/app/services/offplan-to-complete/application/success',
      PMA_REGISTRATION: '/app/services/pma-contract-success',
      PMA_RENEWAL: '/app/services/pma-contract-success',
      PMA_AMENDMENT: '/app/services/pma-contract-success',
      MORTGAGE_RELEASE: `/app/services/mortgage-release/application/download-certificate/${item?.applicationId}`,
      SELL_PURCHASE_LAND: '/app/services/sell-and-purchase/application/success',
      SELL_PURCHASE_UNIT: '/app/services/sell-and-purchase/application/success',
      MORTGAGE_MODIFICATION: `/app/services/mortgage-modification/application/download-certificate/${item?.applicationId}`,
    },
    COMPLETED: {
      OFFPLAN_PROJECT_REGISTRATION: '/app/services/offplan-project-registration/application/success',
      OFF_PLAN_TERMINATION: '/app/services/off-plan-termination/application/success',
      ESCROW_ACCOUNT_REGISTRATION: '/app/services/escrow-account-registration/application/success',
      SERVICE_PROVIDERS_PAYMENT_APPROVAL: '/app/services/escrow-service-provider-payment-approval/application/success',
      OFFPLAN_TERMINATION_LEGAL_NOTICE: `/app/application/details/legal-notice/${item?.applicationId}`,
    },
    BROKER_REVIEW: {
      PERMIT_ADVERTISEMENT_BROKER_LAND: `/app/application/request-permit-advertisement/post-approvals/${item?.applicationId}`,
      PERMIT_ADVERTISEMENT_BROKER_UNIT: `/app/application/request-permit-advertisement/post-approvals/${item?.applicationId}`,
    },
    BROKER_RETURN: {
      PERMIT_ADVERTISEMENT_BROKER_LAND: `/app/application/request-permit-advertisement/post-returns/${item?.applicationId}`,
      PERMIT_ADVERTISEMENT_BROKER_UNIT: `/app/application/request-permit-advertisement/post-returns/${item?.applicationId}`,
    },
    // ................ DRC Special Cases
    RESOLVED_DISPUTE_LETTER: {
      DRC_REGISTRATION: '/app/services/dispute-registration/application/success',
    },
    UNRESOLVED_DISPUTE_LETTER: {
      DRC_REGISTRATION: '/app/services/dispute-registration/application/success',
    },
    CONCEDED_CASE_LETTER: {
      DRC_REGISTRATION: '/app/services/dispute-registration/application/success',
    },
    DROPPED_CASE_LETTER: {
      DRC_REGISTRATION: '/app/services/dispute-registration/application/success',
    },
    STRIKED_CASE_LETTER: {
      DRC_REGISTRATION: '/app/services/dispute-registration/application/success',
    },
    SETTLEMENT_APPROVAL: {
      DRC_REGISTRATION: `/app/applications/dispute-registration/post-approvals/${item?.applicationId}`,
    },
    DROPPED_CASE: {
      DRC_REGISTRATION: `/app/applications/dispute-registration/post-approvals/${item?.applicationId}`,
    },
    RESUBMIT_DROPPED_CASE: {
      DRC_REGISTRATION: `/app/applications/dispute-registration/post-approvals/${item?.applicationId}`,
    },
    CONCESSION_CASE: {
      DRC_REGISTRATION: `/app/applications/dispute-registration/post-approvals/${item?.applicationId}`,
    },
    STRIKE_CASE: {
      DRC_REGISTRATION: `/app/applications/dispute-registration/post-approvals/${item?.applicationId}`,
    },
    EXTEND_APPROVAL: {
      DRC_REGISTRATION: `/app/applications/dispute-registration/post-approvals/${item?.applicationId}`,
    },
    PLAINTIFF_SUBMIT_APPROVAL: {
      DRC_REGISTRATION: `/app/applications/dispute-registration/post-approvals/${item?.applicationId}`,
    },
    EXPERT_OPINION: {
      DRC_EXPERT_OPINION: `/app/applications/request-expert-opinion/post-approvals/${item?.applicationId}`,
    },
    RESOLVED_DISPUTE_STAMPED_LETTER: {
      DRC_EXECUTION_STAMP: '/app/services/drc-execution-stamp/application/success',
    },
    // .............Service Provider
    PENDING_INSPECTION_AUDITOR_REVIEW: {
      SERVICE_PROVIDERS_PAYMENT_APPROVAL: `/app/applications/escrow-service-provider-payment-approval/${item?.applicationId}`,
    },
    INSPECTION_AUDITOR_REVIEW: {
      SERVICE_PROVIDERS_PAYMENT_APPROVAL: `/app/applications/escrow-service-provider-payment-approval/${item?.applicationId}`,
    },
    INSPECTION_APPROVAL: {
      SERVICE_PROVIDERS_PAYMENT_APPROVAL: `/app/applications/escrow-service-provider-payment-approval/${item?.applicationId}`,
    },
    MAKER_FINAL_REVIEW: {
      SERVICE_PROVIDERS_PAYMENT_APPROVAL: `/app/applications/escrow-service-provider-payment-approval/${item?.applicationId}`,
    },
    MAKER_RETURN_TO_INSPECTION: {
      SERVICE_PROVIDERS_PAYMENT_APPROVAL: `/app/applications/escrow-service-provider-payment-approval/post-return/${item?.applicationId}`,
    },
    INSPECTION_RETURN: {
      SERVICE_PROVIDERS_PAYMENT_APPROVAL: `/app/applications/escrow-service-provider-payment-approval/post-return/${item?.applicationId}`,
    },
    INSPECTION_RETURN_TO_AUDITOR: {
      SERVICE_PROVIDERS_PAYMENT_APPROVAL: `/app/applications/escrow-service-provider-payment-approval/post-return/${item?.applicationId}`,
    },
    CHECKER_RETURN_TO_INSPECTION: {
      SERVICE_PROVIDERS_PAYMENT_APPROVAL: `/app/applications/escrow-service-provider-payment-approval/post-return/${item?.applicationId}`,
    },
    CHECKER_RETURN_TO_MAKER: {
      SERVICE_PROVIDERS_PAYMENT_APPROVAL: `/app/applications/escrow-service-provider-payment-approval/post-return/${item?.applicationId}`,
    },
    DMT_RETURN_TO_INSPECTION: {
      SERVICE_PROVIDERS_PAYMENT_APPROVAL: `/app/applications/escrow-service-provider-payment-approval/post-return/${item?.applicationId}`,
    },
    DMT_RETURN_TO_MAKER: {
      SERVICE_PROVIDERS_PAYMENT_APPROVAL: `/app/applications/escrow-service-provider-payment-approval/post-return/${item?.applicationId}`,
    },
    APPLICATION_COMPLETION: {
      SERVICE_PROVIDERS_PAYMENT_APPROVAL: '/app/services/escrow-service-provider-payment-approval/application/success',
    },
    // ................ SPECIAL CASES
    CANCEL_CONFIRM: '/app/applications/lease/lessee-review',
    FINAL_APPROVAL: '/app/applications/lease/owner-review',
    LESSOR_PAYMENT: '/app/applications/lease/owner-review',
    TENANT_PAYMENT: '/app/applications/lease/owner-review',

    REG_PAYMENT: {
      LEASE_REGISTRATION: `/app/applications/lease-payment/${item.applicationId}`,
      LEASE_RENEWAL: `/app/applications/lease-payment/${item.applicationId}`,
      LEASE_AMENDMENT: `/app/applications/lease-payment/${item.applicationId}`,
      OFF_PLAN_FIRST_SELL_LAND: `/app/applications/offplan-buy-sell/payment/${item.applicationId}`,
      OFF_PLAN_FIRST_SELL_UNIT: `/app/applications/offplan-buy-sell/payment/${item.applicationId}`,
      CERT_TITLE_DEED_UNIT: `/app/application/certificates/payment/${item.applicationId}`,
      CERT_TITLE_DEED_PLOT: `/app/application/certificates/payment/${item.applicationId}`,
      CERT_VERIFICATION_UNIT: `/app/application/certificates/payment/${item.applicationId}`,
      CERT_VERIFICATION_PLOT: `/app/application/certificates/payment/${item.applicationId}`,
      CERT_SITE_PLAN_PLOT: `/app/application/certificates/payment/${item.applicationId}`,
      CERT_PROP_OWNERSHIP: `/app/application/certificates/payment/${item.applicationId}`,
      MORTGAGE_REGISTRATION_LAND: `/app/applications/mortgage/payment/${item.applicationId}`,
      MORTGAGE_REGISTRATION_UNIT: `/app/applications/mortgage/payment/${item.applicationId}`,
      MORTGAGE_MODIFICATION: `/app/applications/mortgage-modification/payment/${item.applicationId}`,
      MORTGAGE_RELEASE: `/app/application/detail/mortgage-release/payment/${item.applicationId}`,
      TRANSFER_OF_INTEREST_LAND: `/app/application/transfer-of-interest/payment/${item.applicationId}`,
      TRANSFER_OF_INTEREST_UNIT: `/app/application/transfer-of-interest/payment/${item.applicationId}`,
      DIGITAL_TRANSFER_OF_INTEREST_LAND: `/app/application/digital-transfer-of-interest/payment/${item.applicationId}`,
      DIGITAL_TRANSFER_OF_INTEREST_UNIT: `/app/application/digital-transfer-of-interest/payment/${item.applicationId}`,
      OFF_PLAN_TERMINATION: `/app/application/off-plan-termination/payment/${item.applicationId}`,
      REQUEST_VALUATION_CERTIFICATE_LAND: `/app/services/request-valuation-certificate-land/payment/${item?.applicationId}`,
      REQUEST_VALUATION_CERTIFICATE_UNIT: `/app/services/request-valuation-certificate-unit/payment/${item?.applicationId}`,
      PERMIT_ADVERTISEMENT_BROKER_UNIT: `/app/applications/request-permit-advertisement/payment/${item?.applicationId}`,
      PERMIT_ADVERTISEMENT_BROKER_LAND: `/app/applications/request-permit-advertisement/payment/${item?.applicationId}`,
    },
    SELLER_PAYMENT: {
      TRANSFER_OF_INTEREST_LAND: `/app/application/transfer-of-interest/payment/${item.applicationId}`,
      TRANSFER_OF_INTEREST_UNIT: `/app/application/transfer-of-interest/payment/${item.applicationId}`,
    },
    BUYER_PAYMENT: {
      TRANSFER_OF_INTEREST_LAND: `/app/application/transfer-of-interest/payment/${item.applicationId}`,
      TRANSFER_OF_INTEREST_UNIT: `/app/application/transfer-of-interest/payment/${item.applicationId}`,
    },
    APPOINTMENT_BOOKING: {
      SELL_PURCHASE_LAND: `/app/application/sell-purchase/post-approvals/${item.applicationId}`,
      SELL_PURCHASE_UNIT: `/app/application/sell-purchase/post-approvals/${item.applicationId}`,
    },
    SIGNING_DOCUMENT: {
      SELL_PURCHASE_LAND: `/app/application/sell-purchase/post-approvals/${item.applicationId}`,
      SELL_PURCHASE_UNIT: `/app/application/sell-purchase/post-approvals/${item.applicationId}`,
    },
    DARI_PENDING_SELLER_PAYMENT: {
      SELL_PURCHASE_LAND: `/app/application/sell-purchase/payment/${item.applicationId}`,
      SELL_PURCHASE_UNIT: `/app/application/sell-purchase/payment/${item.applicationId}`,
    },
    DARI_PENDING_BUYER_PAYMENT: {
      SELL_PURCHASE_LAND: `/app/application/sell-purchase/payment/${item.applicationId}`,
      SELL_PURCHASE_UNIT: `/app/application/sell-purchase/payment/${item.applicationId}`,
    },
    // ................ SPECIAL CASES
    PMA_APPROVAL: `/app/applications/pma/post-approvals/${item?.applicationId}`,
    PMA_RETURN: `/app/applications/pma/post-approvals/${item?.applicationId}`,

    // Mortgage Modification Special Cases
    MAKER_REVIEW_RELEASE: {
      MORTGAGE_MODIFICATION: `/app/application/mortgage-modification/post-approvals/${item.applicationId}`,
      TRANSFER_OF_INTEREST_LAND: `/app/application/transfer-of-interest/post-approvals/${item.applicationId}`,
      TRANSFER_OF_INTEREST_UNIT: `/app/application/transfer-of-interest/post-approvals/${item.applicationId}`,
    },
    CHECKER_REVIEW_RELEASE: {
      MORTGAGE_MODIFICATION: `/app/application/mortgage-modification/post-approvals/${item.applicationId}`,
      TRANSFER_OF_INTEREST_LAND: `/app/application/transfer-of-interest/post-approvals/${item.applicationId}`,
      TRANSFER_OF_INTEREST_UNIT: `/app/application/transfer-of-interest/post-approvals/${item.applicationId}`,
    },
    MAKER_RETURN_RELEASE: {
      MORTGAGE_MODIFICATION: `/app/application/mortgage-modification/post-returns/${item.applicationId}`,
      TRANSFER_OF_INTEREST_LAND: `/app/application/transfer-of-interest/post-returns/${item.applicationId}`,
      TRANSFER_OF_INTEREST_UNIT: `/app/application/transfer-of-interest/post-returns/${item.applicationId}`,
    },
    CHECKER_RETURN_RELEASE: {
      MORTGAGE_MODIFICATION: `/app/application/mortgage-modification/post-returns/${item.applicationId}`,
      TRANSFER_OF_INTEREST_LAND: `/app/application/transfer-of-interest/post-returns/${item.applicationId}`,
      TRANSFER_OF_INTEREST_UNIT: `/app/application/transfer-of-interest/post-returns/${item.applicationId}`,
    },
  };

  const url =
    INSANT_SERVICES_TYPES.includes(item.applicationType) && item?.type === 'REG_PAYMENT'
      ? `/app/application/instant-service/payment/${item.applicationId}`
      : typeof tasksMap[item?.type] === 'string'
      ? tasksMap[item?.type]
      : tasksMap[item?.type][item.applicationType] ?? tasksMap[item?.type].default;
  let loggedInUser = null;
  let loginID = null;
  if (localStorage.getItem('selectedAccount')) {
    loggedInUser = JSON.parse(localStorage?.selectedAccount);
    loginID = loggedInUser?.userId ? loggedInUser?.userId : loggedInUser?.companyId;
  }
  history.push({
    pathname: url,
    state: {
      ...item,
      title: item?.applicationType,
      id: item?.applicationId,
      task_id: item.id,
    },
    search:
      '?applicationType=' +
      item?.applicationType +
      '&applicationId=' +
      item?.applicationId +
      '&status=' +
      item?.status +
      '&type=' +
      item?.type +
      '&userid=' +
      loginID,
  });
};
export const flattenObject = obj => {
  return Object.assign(
    {},
    ...(function _flatten(o) {
      return [].concat(
        ...Object.keys(o).map(k =>
          typeof o[k] === 'object' && o[k] !== null && !Array.isArray(o[k]) ? _flatten(o[k]) : { [k]: o[k] },
        ),
      );
    })(obj),
  );
};
export const GetApplicationTypeBySlugName = slugName => {
  switch (slugName) {
    // ********* PMA *********
    case 'pma-renew':
      return 'PMA_RENEWAL';

    case 'pma-amendment':
      return 'PMA_AMENDMENT';

    case 'pma-cancellation':
      return 'PMA_CANCELLATION';

    case 'register-pma':
      return 'PMA_REGISTRATION';

    // ********* Lease *********
    case 'lease-registration':
      return 'LEASE_REGISTRATION';

    case 'lease-cancellation':
      return 'LEASE_CANCELLATION';

    case 'lease-amendment':
      return 'LEASE_AMENDMENT';

    case 'lease-closure':
      return 'LEASE_CLOSURE';

    case 'lease-renewal':
      return 'LEASE_RENEWAL';

    case 'long-lease-to_musataha':
      return 'LONG_LEASE_TO_MUSATAHA';

    // ********* Certificate *********
    case 'issue-title-deed-unit':
      return 'CERT_TITLE_DEED_UNIT';

    case 'issue-title-deed-land':
      return 'CERT_TITLE_DEED_PLOT';

    case 'issue-ownership-certificate':
      return 'CERT_PROP_OWNERSHIP';

    case 'issue-site-plan-land':
      return 'CERT_SITE_PLAN_PLOT';

    case 'issue-verification-certificate-unit':
      return 'CERT_VERIFICATION_UNIT';

    case 'issue-verification-certificate-land':
      return 'CERT_VERIFICATION_PLOT';

    // ********* Company *********
    case 'add-company':
      return 'ADD_COMPANY';

    case 'add-employee':
      return 'ADD_COMPANY_EMPLOYEE';

    // ********* Property *********
    case 'property-registration':
      return 'SELL_PURCHASE';

    case 'waiver-musataha':
      return 'WAIVER_MUSATAHA';

    case 'assign-poa':
      return 'ADD_POA';

    case 'mortgage-registration-land':
      return 'MORTGAGE_REGISTRATION_LAND';

    case 'mortgage-registration-unit':
      return 'MORTGAGE_REGISTRATION_UNIT';

    case 'national-housing-mortgage':
      return 'NATIONAL_HOUSING_MORTGAGE';

    case 'rent-fee-collection':
      return 'RENT_FEE_COLLECTION';

    // case "lease-termination-court-order":
    // ********* NOT FOUND *********
    default:
      return '';
  }
};
// phone number loklaization if + exist or not
export const phoneNumberLokalize = value => {
  if (isEmpty(value)) {
    return null;
  }
  if (value.toString().includes('+')) {
    return keyEmptyCheck('phone_number_val', { s: value.replace('+', '') });
  }
  return value;
};

export const convertStringToDate = stringDate => {
  if (!stringDate) return;
  const date = moment(stringDate).format();
  /* eslint-disable consistent-return */
  return date;
};

export const convertNumberFormat = num => {
  return num;
};

export const textTruncate = str => {
  const length = 18;
  const ending = '...';
  if (str.length > length) {
    return str.substring(0, length - ending.length) + ending;
  }
  return str;
};

export const getCookie = cname => {
  const name = cname + '=';
  const decodedCookie = decodeURIComponent(document.cookie);
  const ca = decodedCookie.split(';');
  for (let i = 0; i < ca.length; i += 1) {
    let c = ca[i];
    while (c.charAt(0) === ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }
  return '';
};

// function to download images as .zip
export const downloadImages = (images, zipname) => {
  // const urls = images.split('|');
  const urls = images;
  if (!urls || urls.length < 1) return;

  const zip = new JSZip();
  const folder = zip.folder('images');

  urls.forEach(url => {
    const blobPromise = fetch(url).then(r => {
      if (r.status === 200) return r.blob();
      return Promise.reject(new Error(r.statusText));
    });
    const name = url.substring(url.lastIndexOf('/') + 1);
    folder.file(name, blobPromise);
  });

  zip.generateAsync({ type: 'blob' }).then(blob => saveAs(blob, zipname));
};

export const downloadPdfWithUrl = (url, name) => {
  const xhr = new XMLHttpRequest();
  xhr.open('GET', url, true);
  xhr.responseType = 'blob';
  // eslint-disable-next-line func-names
  xhr.onload = function() {
    const urlCreator = window.URL || window.webkitURL;
    const imageUrl = urlCreator.createObjectURL(this.response);
    const tag = document.createElement('a');
    tag.href = imageUrl;
    tag.download = name || 'File';
    document.body.appendChild(tag);
    tag.click();
    document.body.removeChild(tag);
  };
  xhr.send();
};

// return icon file name on giving the name of the file along extension
export const getFileIconName = (filename, isUpload) => {
  const extension = filename
    ?.split('.')
    .pop()
    ?.toLowerCase();
  switch (extension) {
    case 'doc':
    case 'docx':
      return 'wordFileIcon.svg';
    case 'pdf':
      return isUpload ? 'doc-paper-pdf.svg' : 'doc-paper-pdf.svg';
    case 'xlsx':
    case 'xls':
      return 'excelFileIcon.svg';
    case 'png':
    case 'jpeg':
    case 'jpg':
      return 'imgFileIcon.svg';
    default:
      return 'fileIcon.svg';
  }
};

export const getTranslatedDate = (dateToFormat, locale) => {
  const dateToString = formatWithOptions({ locale: locale === 'ar' ? ar : en }, 'dd MMMM yyyy');
  const dates = [new Date(dateToFormat)];
  const formattedDate = dates.map(dateToString);
  return formattedDate[0];
};

export function isValidEID(eid) {
  const EID_LENGTH = 15;
  const REGEX_FOR_GETTING_NUMBERS_ONLY = /[^\d]/g;
  return eid?.replace(REGEX_FOR_GETTING_NUMBERS_ONLY, '')?.length === EID_LENGTH;
}

export function validateEmail(email) {
  const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
  return emailRegex.test(email);
}

export const isFeedbackProvided = (intiatorId, feedbackProvided, applicationStatus, userProvided = null) => {
  let loginID;
  if (userProvided) {
    loginID = userProvided?.user?.userId;
  } else {
    loginID = JSON.parse(localStorage.getItem('selectedAccount'));
  }
  if (loginID) {
    if (intiatorId === loginID && !feedbackProvided && applicationStatus === 'COMPLETED') return false;
    return true;
  }
  return true;
};

export const addDataInPreValidations = (validations, data) => {
  if (!isObject(validations) || isEmpty(validations)) return {};
  return Object.keys(validations)?.reduce((result, valKey) => {
    const updatedCurrentValidation = validations[valKey]?.map(valItem => {
      if (isObject(data[valItem?.failureCode])) {
        return {
          ...valItem,
          ...data[valItem?.failureCode],
        };
      }
      return valItem;
    });

    return { ...result, [valKey]: updatedCurrentValidation };
  }, {});
};
